import React from 'react';

// VERSE Clinic wordmark (2:1). Size it by height, e.g. className="h-10".
export const BrandLogo = ({ white, className = 'h-10', testid = 'brand-logo' }) => (
  <img src={white ? '/verse-logo-white.webp' : '/verse-logo.webp'} alt="VERSE Clinic" width={488} height={240} draggable={false}
    className={`${className} w-auto select-none`} data-testid={testid} />
);

export const BrandMark = ({ className = 'h-7 w-7', testid = 'brand-mark' }) => (
  <img src="/verse-mark-v.png" alt="VERSE" width={128} height={128} draggable={false} className={`${className} select-none`} data-testid={testid} />
);
